import { render, staticRenderFns } from "./PayTypeNew.vue?vue&type=template&id=edcfcfd0"
import script from "./PayTypeNew.vue?vue&type=script&lang=js"
export * from "./PayTypeNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports